/* eslint-disable react-hooks/exhaustive-deps */
import Select from "react-select";
import "rsuite/dist/rsuite.css";
import { DateRangePicker } from "rsuite";
import isAfter from "date-fns/isAfter";
import React, { useEffect, useMemo, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { timelogActionRequest } from "../redux/action/timelogAction";
import Utils from "../utility/utility";
import { postApiCall } from "../service/PostApiCall";
import { MANAGE_TIMELOG_HELPER } from "../service/apiUrl";
import CustomModal from "../components/CustomModal";
import DataTable from "../components/table/DataTable";
import {
  ToneLegend,
  clockTime,
  dayState,
  dayTone,
} from "./timelog/timelogTone";

const Timelog = (props) => {
  const [user, setUser] = useState({ value: "", label: "" });
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [helperData, setHelperData] = useState([]);
  const [update, setUpdate] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);

  const dispatch = useDispatch();

  const timelogList = useSelector((state) => state.timelogReducer);
  const signdata = useSelector((state) => state.signinReducers);
  const access_token = signdata?.data?.access_token;

  function closeModal() {
    setIsOpen(false);
  }

  useEffect(() => {
    postApiCall([], access_token, MANAGE_TIMELOG_HELPER)
      .then((result) => {
        setHelperData(result);
      })
      .catch((error) => {
        console.error("MANAGE_TIMELOG_HELPER", error);
      });
  }, []);

  useEffect(() => {
    const params = {
      start_time: fromDate ? Utils.fromDateTimeStamp(fromDate) : "",
      end_time: toDate ? Utils.toDateTimeStamp(toDate) : "",
      orderby: "",
      order: "",
      user_id: user?.value,
      pageSize: pageSize,
      page: currentPage,
    };

    if (access_token) {
      dispatch(timelogActionRequest(params, access_token));
    } else {
      console.error("Timelog List error");
    }
  }, [access_token, dispatch, update]);

  const rows = timelogList?.data?.timelog ?? [];

  const columns = useMemo(
    () => [
      {
        id: "serial",
        header: "#",
        enableSorting: false,
        enableHiding: false,
        meta: { width: "56px" },
        cell: ({ row }) => (
          <span className="text-nowrap">
            {(currentPage - 1) * pageSize + row.index + 1}
          </span>
        ),
      },
      {
        id: "employee",
        header: "Employee",
        enableHiding: false,
        cell: ({ row }) => (
          <span className="text-nowrap fw-medium">
            {row.original?.first_name} {row.original?.last_name}
          </span>
        ),
      },
      {
        id: "formated_date",
        header: "Date",
        cell: ({ row }) => (
          <span className="text-nowrap">
            {row.original?.formated_date ?? "NA"}
          </span>
        ),
      },
      {
        id: "start_time",
        header: "Checkin",
        cell: ({ row }) => (
          <span className="text-nowrap">
            {clockTime(row.original?.start_time)}
          </span>
        ),
      },
      {
        id: "end_time",
        header: "Checkout",
        cell: ({ row }) => (
          <span className="text-nowrap">
            {clockTime(row.original?.end_time)}
          </span>
        ),
      },
      {
        id: "break",
        header: "Break",
        cell: ({ row }) => (
          <span className="text-nowrap">{row.original?.break || "NA"}</span>
        ),
      },
      {
        id: "total_time",
        header: "Total Hour",
        cell: ({ row }) => (
          <span className="text-nowrap">
            {row.original?.total_time ?? "NA"}
          </span>
        ),
      },
      {
        id: "productive_time",
        header: "Productive Hour",
        cell: ({ row }) => (
          <span className="text-nowrap">
            {row.original?.productive_time ?? "NA"}
          </span>
        ),
      },
      {
        /* See the developer listing: the colour used to be the only carrier
           of this. It is a column on both screens now. */
        id: "state",
        header: "State",
        cell: ({ row }) => (
          <span className="text-nowrap">{dayState(row.original)}</span>
        ),
      },
      {
        id: "comments",
        header: "Comments",
        enableSorting: false,
        enableHiding: false,
        cell: ({ row }) =>
          row.original?.no_break_reason ? (
            <button
              type="button"
              className="dt-btn"
              onClick={() => {
                setModalData(row.original?.no_break_reason);
                setIsOpen(true);
              }}
            >
              <i className="fa fa-eye" aria-hidden="true"></i>
              Reason
            </button>
          ) : null,
      },
    ],
    [currentPage, pageSize]
  );

  return (
    <>
      <div className={props?.data?.transtion == true ? "contents" : "content"}>
        <div className="content-top-spacer"></div>
        <div className="color-body">
          <div className="page-head">
            <div className="page-eyebrow">Tracking</div>
            <h1 className="page-title">Timelog</h1>
          </div>
          <div className="col-md-12">
            <div className="card-input mt-3">
              <div className="col-md-12 mb-3">
                <div className="mt-4">
                  <div className="col-md-12"></div>
                  <div className="">
                    <div className="mt-3">
                      <DataTable
                        columns={columns}
                        data={rows}
                        isLoading={timelogList?.isLoading}
                        getRowId={(row, index) => String(row?.id ?? index)}
                        filters={
                          <>
                            <ToneLegend />
                            <div className="listing-filters">
                              <div className="filter-cell">
                                <label className="filter-label">Employee</label>
                                <div className="tl-filter-field">
                                  <Select
                                    classNamePrefix="rs"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    options={helperData?.users}
                                    className={"mt-2 mb-2"}
                                    value={user ?? {}}
                                    isClearable={true}
                                    isSearchable={true}
                                    styles={{
                                      menu: (base) => ({
                                        ...base,
                                        width: "max-content",
                                        minWidth: "100%",
                                      }),
                                    }}
                                    onChange={(event) => {
                                      setUser({
                                        value: event?.value,
                                        label: event?.label,
                                      });
                                      setCurrentPage(1);
                                      setUpdate(!update);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="filter-cell">
                                <label className="filter-label">
                                  Date Range
                                </label>
                                <DateRangePicker
                                  appearance="subtle"
                                  showWeekNumbers
                                  placeholder="Select Dates"
                                  size="sm"
                                  className="mt-2 mb-2 date-range-border"
                                  disabledDate={(date) =>
                                    isAfter(date, new Date())
                                  }
                                  onChange={(date) => {
                                    setFromDate(date ? date[0] : new Date());
                                    setToDate(date ? date[1] : new Date());
                                    setCurrentPage(1);
                                    setUpdate(!update);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        }
                        /* Server mode: this is one page of days, so there is
                           nothing honest to sort or facet on. Employee and
                           date range are the filters, and the API owns both. */
                        sorting={false}
                        rowTone={(row) => dayTone(row.original)}
                        pagination={{
                          manual: true,
                          pageIndex: currentPage - 1,
                          pageSize: pageSize,
                          pageCount: timelogList?.data?.total_pages ?? -1,
                          pageSizeOptions: [30, 50, 100],
                          onChange: (next) => {
                            // a new page size re-slices the whole result, so
                            // the page number it was paired with is meaningless
                            const resized = next.pageSize !== pageSize;
                            setCurrentPage(resized ? 1 : next.pageIndex + 1);
                            setPageSize(next.pageSize);
                            setUpdate((flag) => !flag);
                          },
                        }}
                        emptyText="No record found"
                      />

                      <CustomModal
                        isShow={modalIsOpen}
                        onHide={closeModal}
                        heading="No break reason"
                        footer={
                          <button
                            type="button"
                            className="app-dialog-btn app-dialog-btn-ghost"
                            onClick={closeModal}
                          >
                            Close
                          </button>
                        }
                      >
                        <p className="app-dialog-lede">
                          {modalData || "No reason was given."}
                        </p>
                      </CustomModal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Timelog;
